// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleSettingsPopup__container-ba28d8 {
  width: 400px;
  flex: none;
}

.ScheduleSettingsPopup__content-ab6c46 {
  display: flex;
  flex-direction: row;
  padding: 24px;
}

.ScheduleSettingsPopup__footer-f0e0c3 {
  gap: 12px;
}

.ScheduleSettingsPopup__date-ac4744 {
  width: 200px;
  margin-inline-end: 16px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduleSettingsPopup/ScheduleSettingsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  width: 400px;\n  flex: none;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  padding: 24px;\n}\n\n.footer {\n  gap: 12px;\n}\n\n.date {\n  width: 200px;\n  margin-inline-end: 16px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduleSettingsPopup__container-ba28d8`,
	"content": `ScheduleSettingsPopup__content-ab6c46`,
	"footer": `ScheduleSettingsPopup__footer-f0e0c3`,
	"date": `ScheduleSettingsPopup__date-ac4744`
};
module.exports = ___CSS_LOADER_EXPORT___;
